import React from 'react';
import Unsplash from './components/Unsplash'
import Footer from './components/common/Footer'

import './assets/css/style.css'

function App() {
  return (
    <>
    <Unsplash />
    <Footer />
    </>
  );
}

export default App;
